const COOKIE_NAME = 'lens_token';
const COOKIE_DOMAIN = '.aivilo.ai';

export function setToken(token: string): void {
  localStorage.setItem('token', token);
  document.cookie = `${COOKIE_NAME}=${token}; domain=${COOKIE_DOMAIN}; path=/; secure; samesite=lax; max-age=86400`;
}

export function clearToken(): void {
  localStorage.removeItem('token');
  document.cookie = `${COOKIE_NAME}=; domain=${COOKIE_DOMAIN}; path=/; max-age=0`;
}
